// Comandos do agregado Funcionário — criar, editar, inativar/reativar. Dado
// puro; o executor só chama o domínio. `id` no `criar` vem do cliente
// (ADR-0003).

import type { Snapshot } from "../domain/snapshot.ts";
import {
  criarFuncionario,
  definirAtivoFuncionario,
  editarFuncionario,
  type DadosFuncionario,
} from "../domain/funcionarios.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirBooleano, exigirTexto, texto } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

// O comando referencia `DadosFuncionario` do domínio, não uma cópia (ADR-0013).
export type ComandoFuncionario =
  | { tipo: "criar"; id: string; dados: DadosFuncionario }
  | { tipo: "editar"; id: string; dados: DadosFuncionario }
  | { tipo: "definirAtivo"; id: string; ativo: boolean };

export function executarComandoFuncionario(
  snapshot: Snapshot,
  cmd: ComandoFuncionario,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "criar":
      return criarFuncionario(snapshot, cmd.dados, cmd.id);
    case "editar":
      return editarFuncionario(snapshot, cmd.id, cmd.dados);
    case "definirAtivo":
      return definirAtivoFuncionario(snapshot, cmd.id, cmd.ativo);
    default:
      return assertNunca(cmd);
  }
}

function validarDados(valor: unknown): DadosFuncionario {
  const o = comoObjeto(valor, "Dados do funcionário");
  return {
    nome: texto(o.nome),
    funcao: texto(o.funcao),
    contato: texto(o.contato),
    admissao: texto(o.admissao),
  };
}

export function validarComandoFuncionario(valor: unknown): ComandoFuncionario {
  const c = comoObjeto(valor, "Comando de funcionário");
  switch (c.tipo) {
    case "criar":
      return {
        tipo: "criar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "editar":
      return {
        tipo: "editar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "definirAtivo":
      return {
        tipo: "definirAtivo",
        id: exigirTexto(c.id, "id"),
        ativo: exigirBooleano(c.ativo, "ativo"),
      };
    default:
      throw new Error(
        `Tipo de comando de funcionário desconhecido: ${String(c.tipo)}.`,
      );
  }
}
